module.exports = __webpack_public_path__ + "static/media/ic-villagemd-v.c313128f.svg";